import { request } from '@umijs/max';

// 获取订单列表
export async function getOrderList(
    params: API.OrderSearchParams,
    options?: { [key: string]: any },
) {
    return request<API.OrderListResult>('/order', {
        method: 'GET',
        params: {
            ...params,
        },
        ...(options || {}),
    });
}

// 获取订单详情（包含关联数据）
export async function getOrderDetail(
    id: string,
    options?: { [key: string]: any },
) {
    return request<API.OrderWithRelationsResult>(`/order/${id}/with-relations`, {
        method: 'GET',
        ...(options || {}),
    });
}

// 确认订单支付
export async function confirmOrderPayment(
    orderId: string,
    password: string,
    options?: { [key: string]: any },
) {
    return request<API.StandardResponse<any>>('/order/confirm-payment', {
        method: 'POST',
        data: {
            orderId,
            password,
        },
        ...(options || {}),
    });
}

// 立即发送回调
export async function immediateCallback(
    orderNo: string,
    options?: { [key: string]: any },
) {
    return request<API.StandardResponse<null>>('/order/immediate-callback', {
        method: 'POST',
        data: {
            order_no: orderNo,
        },
        ...(options || {}),
    });
}

// 获取今日订单统计数据
export async function getTodayOrderStatistics(
    params?: API.TimeRangeQueryDto,
    options?: { [key: string]: any },
) {
    return request<API.OrderStatisticsResult>('/statistics/orders/today', {
        method: 'GET',
        params: {
            ...params,
        },
        ...(options || {}),
    });
}

// 获取本周订单统计数据
export async function getWeeklyOrderStatistics(
    params?: API.TimeRangeQueryDto,
    options?: { [key: string]: any },
) {
    return request<API.WeeklyOrderStatisticsResult>('/statistics/orders/week', {
        method: 'GET',
        params: {
            ...params,
        },
        ...(options || {}),
    });
}

// 获取本月订单统计数据
export async function getMonthlyOrderStatistics(
    params?: API.TimeRangeQueryDto,
    options?: { [key: string]: any },
) {
    return request<API.MonthlyOrderStatisticsResult>('/statistics/orders/month', {
        method: 'GET',
        params: {
            ...params,
        },
        ...(options || {}),
    });
}

// 获取接单顺位
export async function getOrderQueuePosition(
    options?: { [key: string]: any },
) {
    return request<API.OrderQueuePositionResult>('/order/queue-position', {
        method: 'GET',
        ...(options || {}),
    });
} 